export type CsvImportIssue = {
  rowNumber: number | string;
  errors?: Record<string, string[]>;
  warnings?: Record<string, string[]>;
};

export type AdSyncError = string | unknown[];

export const USER_ERROR_CODES = [
  'user.already.assigned.to.branch',
  'user.already.exists.in.another.account',
  'user.no.email.provided',
  'user.duplicate.username',
];

export const normalizeErrorMessage = (message: string): string => {
  const aadstsMatch = message.match(/AADSTS(\d+)/);

  if (aadstsMatch) {
    const descriptionMatch = message.match(/Description:\s*(.+?)(?:\s+-\s+|$)/);
    const humanMessage = descriptionMatch?.[1]?.trim();

    if (humanMessage) {
      return humanMessage;
    }
  }

  if (message.length > 200) {
    return message.substring(0, 200) + '...';
  }

  return message;
};

export const extractUserIdentifier = (
  errorCode: string,
  params: unknown[],
): string => {
  if (!Array.isArray(params) || params.length === 0) return '-';

  switch (errorCode) {
    case 'user.already.exists.in.another.account':
      return String(params[0] || params[2] || '-');
    case 'user.no.email.provided': {
      const name = [params[0], params[1]].filter(Boolean).join(' ');
      return name || String(params[2] || '-');
    }
    case 'user.duplicate.username': {
      const name = [params[0], params[1]].filter(Boolean).join(' ');
      return String(params[2] || name || '-');
    }
    case 'user.already.assigned.to.branch':
      return String(params[0] || '-');
    default:
      return String(params[0] || '-');
  }
};
